import classNames from 'classnames';
import { MultiSelect } from 'components/Icons';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import styles from './styles.module.scss';
import { Icons } from 'pages/Workshop/Icons';
import { getUserRolesMapSelector } from 'store/selectors/user';
import { FormSelectFilter } from '../../LocalHeader/FormSelectFilter';
import { Filter } from '../../Filter';

export const FormActionButtons = (props) => {
  const { isAgent } = useSelector(getUserRolesMapSelector);

  const { onSearchClick, showSelection, onShowSelection, onNewFormClick } = props;

  const renderNewButton = () => {
    return (
      <div className={classNames(styles.btn, styles.newBtn)} onClick={onNewFormClick}>
        <Icons className={styles.addIcon} variant={Icons.ADD} />
        <span className={styles.iconText}>New</span>
      </div>
    );
  };

  return (
    <div className={styles.actionButtonsPanel}>
      {isAgent && renderNewButton()}

      <FormSelectFilter />

      <div className={classNames(styles.btn)} onClick={onSearchClick}>
        <Icons className={styles.btnIcon} variant={Icons.SEARCH} color="#515151" />
      </div>

      <Filter />

      {isAgent && (
        <div
          className={classNames(styles.btn, styles.selectionButton, {
            [styles.activeButton]: showSelection,
          })}
          onClick={() => onShowSelection(!showSelection)}
        >
          <MultiSelect />
        </div>
      )}
    </div>
  );
};
